import type { CONTENT_TYPE, SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/public-filter-constants';

// LogicalOperator enum based on OpenAPI spec
export enum LogicalOperator {
  None = 0,
  And = 1,
  Or = 2,
}

export enum QUERY_FILTER_TYPE {
  WORD = 'word',
  USERNAME = 'username',
}

export type QueryFilterExpressionValue = {
  type: QUERY_FILTER_TYPE;
  value: string;
};

export interface QueryFilterExpressionUnit {
  op: LogicalOperator;
  values: QueryFilterExpressionValue[];
}

export interface QueryFilterExpression {
  exclude: QueryFilterExpressionUnit;
  include: QueryFilterExpressionUnit[];
}

export interface QueryDate {
  day: number;
  month: number;
  year: number;
}

export interface SavedQuery extends SavedQueryBody {
  id: string;
  type: 'private' | 'public';
  name: string;
}

export interface SavedQueryBody {
  filter: QueryFilterExpression;
  options: SavedQueryOptions;
}

export interface SavedQueryOptions {
  sponsored_post: CONTENT_TYPE;
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export type QueryStatus = {
  platform: SOURCE_PLATFORM_TYPE;
  status: 'running' | 'completed' | 'failed' | 'canceled';
};
